// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UJAt","icon":"styles_icon__1tXPI"};